module.exports = "/_next/static/images/logo-aman-1-df4d989665eb64448b6b0260a3180185.png";